export const CountryNamesENG =
{   "KX":"", // Disputed Kashmir/Jammu/China rectangle
    "PI":"", // Islands, Portugal sovereignty PRT1202
    "EI":"", // Islands, Spanish sovereignty ESP1393
    "II":"", // Ilemi Triangle
    "KU":"", // Kunashir
    "AP":"", // Arunachal Pradesh
    "QQ":"", // Territory with Sudan
    "QG":"", // Territory with Egypt
    "TV":"TUVALU",//"Tuvalu",
    "BV":"",
    "GI":"",
    "GO":"",
    "JU":"",
    "UM-DQ":"",
    "UM-FQ":"",	
    "UM-HQ":"",	
    "UM-JQ":"",	
    "UM-MQ":"",	
    "UM-WQ":"",	
    "BQ":"",
    "NL":"THE KINGDOM OF THE NETHERLANDS",//"NETHERLANDS",//"Netherlands (Kingdom of the)", //UPDATED 3-28
    "ZW":"ZIMBABWE",//"Zimbabwe",
    "ZM":"ZAMBIA",//"Zambia",
    "ZA":"SOUTH AFRICA",//"South Africa",
    "YE":"YEMEN",//"Yemen",
    "WS":"SAMOA",//"Samoa",
    "WF":"",
    "TWN":"",
    "xJK":"",
    //"PS":"WEST BANK & GAZA",//"West Bank & Gaza",
    "PS":"OCCUPIED PALESTINIAN TERRITORY",//"STATE OF PALESTINE",//"West Bank & Gaza",
    //"PX":"WEST BANK",//"West Bank & Gaza",
    "VU":"VANUATU",//"Vanuatu",
    "VN":"VIET NAM",//"Viet Nam",
    "VI":"",
    "VG":"",
    "FLK":"",
    "VE":"VENEZUELA",//"Venezuela",//UPDATED 3-28 (was "Venezuela (Bolivarian Republic of)"),
    "VC":"SAINT VINCENT AND THE GRENADINES",//"Saint Vincent and the Grenadines",
    "VA":"",
    "UZ":"UZBEKISTAN",//"Uzbekistan",
    "US":"UNITED STATES OF AMERICA",//"United States of America",//UPDATED 3-28 (was "United States of America (the)"),
    "UY":"URUGUAY",//"Uruguay",
    "UA":"UKRAINE",//"Ukraine",
    "UG":"UGANDA",//"Uganda",
    "TZ":"UNITED REPUBLIC OF TANZANIA",//"United Republic of Tanzania"//UPDATED 3-28 (was "United Republic of Tanzania (the)",
    "TW":"",
    "TR":"TÜRKİYE",//"TÜRKIYE",//"Türkiye",//"Turkey",
    "TN":"TUNISIA",
    "TT":"TRINIDAD AND TOBAGO",//"Trinidad and Tobago",
    "TO":"TONGA",
    "TL":"TIMOR-LESTE",//"Timor-Leste",
    "TM":"TURKMENISTAN",
    "TK":"", // TOKELAU
    "TJ":"TAJIKISTAN",
    "TH":"THAILAND",
    "TG":"TOGO",
    "TD":"CHAD",
    "TC":"",
    "SY":"SYRIAN ARAB REPUBLIC", //UPDATED 3-28 (was "Syrian Arab Republic (the)"),
    "SC":"SEYCHELLES",
    "SX":"",
    "SZ":"ESWATINI",
    "SE":"SWEDEN",
    "SI":"SLOVENIA",
    "SK":"SLOVAKIA",
    "SR":"SURINAME",
    "ST":"SAO TOME AND PRINCIPE",
    "RS":"SERBIA",
    "PM":"",
    "SO":"SOMALIA",
    "SM":"SAN MARINO",
    "SV":"EL SALVADOR",
    "SL":"SIERRA LEONE",
    "SB":"SOLOMON ISLANDS",
    "SH":"",
    "GS":"",
    "SG":"SINGAPORE",
    "SN":"SENEGAL",
    "SS":"SOUTH SUDAN",
    "SD":"SUDAN", //UPDATED 3-28 (WAS "SUDAN (THE)")
    "SA":"SAUDI ARABIA",
    "EH":"",
    "RW":"RWANDA",
    "RU":"RUSSIAN FEDERATION",//UPDATED 3-28 (WAS "RUSSIAN FEDERATION (THE)"),
    "RO":"ROMANIA",
    "RE":"",
    "QA":"QATAR",
    "PF":"",
    "PY":"PARAGUAY",
    "PT":"PORTUGAL",
    "KP":"DEMOCRATIC PEOPLE'S REPUBLIC OF KOREA",//UPDATED 3-28 (WAS "DEMOCRATIC PEOPLE'S REPUBLIC OF KOREA (THE)",
    "PR":"",
    "PL":"POLAND",
    "PG":"PAPUA NEW GUINEA",
    "PW":"PALAU",
    "PH":"PHILIPPINES",//UPDATED 3-28 (WAS "PHILIPPINES (THE)")
    "PE":"PERU",
    "PN":"",
    "PA":"PANAMA",
    "PK":"PAKISTAN",
    "OM":"OMAN",
    "NZ":"NEW ZEALAND",
    "SJ":"",
    "NR":"NAURU",
    "NP":"NEPAL",
    "NO":"NORWAY",
    "NU":"NIUE",
    "NI":"NICARAGUA",
    "NG":"NIGERIA",
    "NF":"",
    "NE":"NIGER", //UPDATED 3-28 (WAS "NIGER (THE)")
    "NC":"",
    "NA":"NAMIBIA",
    "YT":"",
    "MY":"MALAYSIA",
    "MW":"MALAWI",
    "MU":"MAURITIUS",
    "MQ":"",
    "MS":"",
    "MR":"MAURITANIA",
    "MZ":"MOZAMBIQUE",
    "MP":"",
    "MN":"MONGOLIA",
    "ME":"MONTENEGRO",
    "MM":"MYANMAR",
    "MT":"MALTA",
    "ML":"MALI",
    "MK":"NORTH MACEDONIA",
    "MH":"MARSHALL ISLANDS", //UPDATED 3-28 (WAS "MARSHALL ISLANDS (THE)")
    "MX":"MEXICO",
    "MV":"MALDIVES",
    "MG":"MADAGASCAR",
    "MD":"REPUBLIC OF MOLDOVA",//UPDATED 3-28 (WAS "REPUBLIC OF MOLDOVA (THE)")
    "MC":"MONACO",
    "MA":"MOROCCO",
    "MF":"",
    "MO":"",
    "LV":"LATVIA",
    "LU":"LUXEMBOURG",
    "LT":"LITHUANIA",
    "LS":"LESOTHO",
    "LK":"SRI LANKA",
    "LI":"LIECHTENSTEIN",
    "LC":"SAINT LUCIA",
    "LY":"LIBYA",
    "LR":"LIBERIA",
    "LB":"LEBANON",
    "LA":"LAO PEOPLE'S DEMOCRATIC REPUBLIC",//UPDATED 3-28 (WAS "LAO PEOPLE'S DEMOCRATIC REPUBLIC (THE)")
    "KW":"KUWAIT",
    "XK":"", //
    "KR":"REPUBLIC OF KOREA",//UPDATED 3-28 (WAS "REPUBLIC OF KOREA (THE)")
    "KN":"SAINT KITTS AND NEVIS",
    "KI":"KIRIBATI",
    "KH":"CAMBODIA",
    "KG":"KYRGYZSTAN",
    "KE":"KENYA",
    "KZ":"KAZAKHSTAN",
    "JP":"JAPAN",
    "JO":"JORDAN",
    "JE":"",
    "JM":"JAMAICA",
    "IT":"ITALY",
    "IL":"ISRAEL",
    "IS":"ICELAND",
    "IQ":"IRAQ",
    "IR":"IRAN (ISLAMIC REPUBLIC OF)",
    "IE":"IRELAND",
    "IO":"",
    "IN":"INDIA",
    "IM":"",
    "ID":"INDONESIA",
    "HU":"HUNGARY",
    "HT":"HAITI",
    "HR":"CROATIA",
    "HN":"HONDURAS",
    "HM":"",
    "HK":"",
    "GY":"GUYANA",
    "GU":"",
    "GF":"",
    "GT":"GUATEMALA",
    "GL":"",
    "GD":"GRENADA",
    "GR":"GREECE",
    "GQ":"EQUATORIAL GUINEA",
    "GW":"GUINEA-BISSAU",
    "GM":"GAMBIA", //UPDATED 3-28 (WAS "GAMBIA (THE)",)
    "GP":"",
    "GN":"GUINEA",
    "GH":"GHANA",
    "GG":"",
    "GE":"GEORGIA",
    "GA":"GABON",
    "FR":"FRANCE",
    "FM":"MICRONESIA (FEDERATED STATES OF)",
    "FO":"",
    "FK":"",
    "FJ":"FIJI",
    "FI":"FINLAND",
    "ET":"ETHIOPIA",
    "EE":"ESTONIA",
    "ES":"SPAIN",
    "ER":"ERITREA",
    "GB":"UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND", // UPDATED 3-28 (WAS "UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND (THE)")
    "EG":"EGYPT",
    "EC":"ECUADOR",
    "DZ":"ALGERIA",
    "DO":"DOMINICAN REPUBLIC", //UPDATED 3-28 (WAS "DOMINICAN REPUBLIC (THE)")
    "DK":"DENMARK",
    "DM":"DOMINICA",
    "DJ":"DJIBOUTI",
    "DE":"GERMANY",
    "CZ":"CZECHIA",
    "CY":"CYPRUS",
    "KY":"", //
    "CX":"",
    "CW":"",
    "CU":"CUBA",
    "CR":"COSTA RICA",
    "CV":"CABO VERDE",
    "KM":"COMOROS", //UPDATED 3-28 (WAS "COMOROS (THE)")
    "CO":"COLOMBIA",
    "CK":"COOK ISLANDS",//UPDATED 3-28 (WAS "COOK ISLANDS (THE)")
    "CG":"CONGO",//UPDATED 3-28 (WAS "CONGO (THE)"
    "CD":"DEMOCRATIC REPUBLIC OF THE CONGO",//UPDATED 3-28 (WAS "DEMOCRATIC REPUBLIC OF THE CONGO (THE)"
    "CM":"CAMEROON",
    "CI":"CÔTE D'IVOIRE",
    "CN":"CHINA",
    "CL":"CHILE",
    "CH":"SWITZERLAND",
    "CC":"",
    "CA":"CANADA",
    "CF":"CENTRAL AFRICAN REPUBLIC",//UPDATED 3-28 "CENTRAL AFRICAN REPUBLIC (THE)"
    "BE":"BELGIUM",
    "BW":"BOTSWANA",
    "BT":"BHUTAN",
    "BN":"BRUNEI DARUSSALAM",
    "BB":"BARBADOS",
    "BR":"BRAZIL",
    "BO":"BOLIVIA (BOLIVARIAN REPUBLIC OF)", //UPDATED 3-28 (WAS "BOLIVIA (PLURINATIONAL STATE OF)",***
    "BM":"",
    "BZ":"BELIZE",
    "BY":"BELARUS",
    "BL":"",
    "BS":"BAHAMAS", //UPDATED 3-28 (WAS "BAHAMAS (THE)"
    "BH":"BAHRAIN",
    "BA":"BOSNIA AND HERZEGOVINA",
    "BG":"BULGARIA",
    "BD":"BANGLADESH",
    "BF":"BURKINA FASO",
    "BJ":"BENIN",
    "BI":"BURUNDI",
    "AZ":"AZERBAIJAN",
    "AT":"AUSTRIA",
    "AU":"AUSTRALIA",
    "TF":"",
    "AQ":"",
    "AS":"",
    "AM":"ARMENIA",
    "AR":"ARGENTINA",
    "AE":"UNITED ARAB EMIRATES",//UPDATED 3-28 (WAS "UNITED ARAB EMIRATES (THE)")
    "AD":"ANDORRA",
    "AX":"",
    "AL":"ALBANIA",
    "AI":"",
    "AO":"ANGOLA",
    "AF":"AFGHANISTAN",
    "AG":"ANTIGUA AND BARBUDA",
    "AW":"",
    // "SSD_xIT":"HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH"
  };

export const CountryNamesCHN = 
{ 
  "KU":"", // Kunashir
  "AP":"",
  "QQ":"", // Territory with Sudan
  "QG":"", // Territory with Egypt
  "TV":"图瓦卢 ",
  "BV":"",
  "GI":"",
  "GO":"",
  "JU":"",
  "UM-DQ":"",	
  "UM-FQ":"",	
  "UM-HQ":"",	
  "UM-JQ":"",	
  "UM-MQ":"",	
  "UM-WQ":"",	
  "BQ":"",
  "NL":"荷兰王国",//"荷兰 ",
  "ZW":"津巴布韦 ",
  "ZM":"赞比亚 ",
  "ZA":"南非 ",
  "YE":"也门 ",
  "WS":"萨摩亚 ",
  "WF":"",
  "PS":"巴勒斯坦被占领土",//Occupied Palestinian Territory
  //"PS":"巴勒斯坦国 ",//STATE OF PALESTINE
  //"PS":"加沙 ", // Gaza
  //"PX":"约旦河西岸 ", // West Bank
  "VU":"瓦努阿图 ",
  "VN":"越南 ",
  "VI":"",
  "VG":"",
  "VE":"委内瑞拉玻利瓦尔共和国 ",
  "VC":"圣文森特和格林纳丁斯 ",
  "VA":"",
  "UZ":"乌兹别克斯坦 ",
  "US":"美利坚合众国 ",
  "UY":"乌拉圭 ",
  "UA":"乌克兰 ",
  "UG":"乌干达 ",
  "TZ":"坦桑尼亚联合共和国 ",
  "TW":"",
  "TR":"土耳其",//"土耳其 ",
  "TN":"突尼斯 ",
  "TT":"特立尼达和多巴哥 ",
  "TO":"",
  "TL":"东帝汶 ",
  "TM":"土库曼斯坦 ",
  "TK":"",
  "TJ":"塔吉克斯坦 ",
  "TH":"泰国 ",
  "TG":"多哥 ",
  "TD":"乍得 ",
  "TC":"",
  "SY":"阿拉伯叙利亚共和国 ",
  "SC":"塞舌尔 ",
  "SX":"",
  "SZ":"斯威士兰 ",
  "SE":"瑞典 ",
  "SI":"斯洛文尼亚 ",
  "SK":"斯洛伐克 ",
  "SR":"苏里南 ",
  "ST":"圣多美和普林西比 ",
  "RS":"塞尔维亚 ",
  "PM":"",
  "SO":"索马里 ",
  "SM":"圣马力诺 ",
  "SV":"萨尔瓦多 ",
  "SL":"塞拉利昂 ",
  "SB":"所罗门群岛 ",
  "SH":"",
  "GS":"",
  "SG":"新加坡 ",
  "SN":"塞内加尔 ",
  "SS":"南苏丹 ",
  "SD":"苏丹 ",
  "SA":"沙特阿拉伯 ",
  "EH":"",
  "RW":"卢旺达 ",
  "RU":"俄罗斯联邦",
  "RO":"罗马尼亚 ",
  "RE":"",
  "QA":"卡塔尔 ",
  "PF":"",
  "PY":"巴拉圭 ",
  "PT":"葡萄牙 ",
  "KP":"朝鲜民主主义人民共和国 ",
  "PR":"",
  "PL":"波兰 ",
  "PG":"巴布亚新几内亚 ",
  "PW":"帕劳 ",
  "PH":"菲律宾 ",
  "PE":"秘鲁 ",
  "PN":"",
  "PA":"巴拿马 ",
  "PK":"巴基斯坦 ",
  "OM":"阿曼 ",
  "NZ":"新西兰 ",
  "SJ":"",
  "NR":"瑙鲁",
  "NP":"尼泊尔 ",
  "NO":"挪威 ",
  "NU":"纽埃 ",
  "NI":"尼加拉瓜 ",
  "NG":"尼日利亚 ",
  "NF":"",
  "NE":"尼日尔 ",
  "NC":"",
  "NA":"纳米比亚",
  "YT":"",
  "MY":"马来西亚 ",
  "MW":"马拉维 ",
  "MU":"毛里求斯 ",
  "MQ":"",
  "MS":"",
  "MR":"毛里塔尼亚 ",
  "MZ":"莫桑比克 ",
  "MP":"",
  "MN":"蒙古 ",
  "ME":"黑山 ",
  "MM":"缅甸 ",
  "MT":"马耳他 ",
  "ML":"马里 ",
  "MK":"北马其顿 ",
  "MH":"马绍尔群岛 ",
  "MX":"墨西哥 ",
  "MV":"马尔代夫 ",
  "MG":"马达加斯加 ",
  "MD":"摩尔多瓦共和国 ",
  "MC":"摩纳哥 ",
  "MA":"摩洛哥 ",
  "MF":"",
  "MO":"",
  "LV":"拉脱维亚 ",
  "LU":"卢森堡 ",
  "LT":"立陶宛 ",
  "LS":"莱索托 ",
  "LK":"斯里兰卡 ",
  "LI":"列支敦士登",
  "LC":"圣卢西亚 ",
  "LY":"利比亚 ",
  "LR":"利比里亚 ",
  "LB":"黎巴嫩 ",
  "LA":"老挝人民民主共和国 ",
  "KW":"科威特 ",
  "XK":"",
  "KR":"大韩民国 ",
  "KN":"圣基茨和尼维斯 ",
  "KI":"基里巴斯 ",
  "KH":"柬埔寨 ",
  "KG":"吉尔吉斯斯坦 ",
  "KE":"肯尼亚 ",
  "KZ":"哈萨克斯坦 ",
  "JP":"日本 ",
  "JO":"约旦 ",
  "JE":"",
  "JM":"牙买加 ",
  "IT":"意大利",
  "IL":"以色列 ",
  "IS":"冰岛 ",
  "IQ":"伊拉克 ",
  "IR":"伊朗伊斯兰共和国 ",
  "IE":"爱尔兰 ",
  "IO":"",
  "IN":"印度 ",
  "IM":"",
  "ID":"印度尼西亚 ",
  "HU":"匈牙利 ",
  "HT":"海地 ",
  "HR":"克罗地亚 ",
  "HN":"洪都拉斯 ",
  "HM":"",
  "HK":"", 
  "GY":"圭亚那 ",
  "GU":"",
  "GF":"",
  "GT":"危地马拉 ",
  "GL":"",
  "GD":"格林纳达 ",
  "GR":"希腊 ",
  "GQ":"赤道几内亚 ",
  "GW":"几内亚比绍 ",
  "GM":"冈比亚 ",
  "GP":"",
  "GN":"几内亚 ",
  "GH":"加纳 ",
  "GG":"",
  "GE":"格鲁吉亚 ",
  "GA":"加蓬 ",
  "FR":"法国 ",
  "FM":"密克罗尼西亚联邦 ",
  "FO":"",
  "FK":"",
  "FJ":"斐济 ",
  "FI":"芬兰 ",
  "ET":"埃塞俄比亚 ",
  "EE":"爱沙尼亚 ",
  "ES":"西班牙 ",
  "ER":"厄立特里亚 ",
  "GB":"大不列颠及北爱尔兰联合王国 ",
  "EG":"埃及 ",
  "EC":"厄瓜多尔 ",
  "DZ":"阿尔及利亚 ",
  "DO":"多米尼加 ",
  "DK":"丹麦 ",
  "DM":"多米尼克 ",
  "DJ":"吉布提 ",
  "DE":"德国 ",
  "CZ":"捷克 ",
  "CY":"塞浦路斯 ",
  "KY":"",
  "CX":"",
  "CW":"",
  "CU":"古巴 ",
  "CR":"哥斯达黎加",
  "CV":"佛得角 ",
  "KM":"科摩罗 ",
  "CO":"哥伦比亚 ",
  "CK":"库克群岛 ",
  "CG":"刚果（布） ",
  "CD":"刚果民主共和国 ",
  "CM":"喀麦隆",
  "CI":"科特迪瓦 ",
  "CN":"中国 ",
  "CL":"智利 ",
  "CH":"瑞士 ",
  "CC":"",
  "CA":"加拿大 ",
  "CF":"中非共和国",
  "BE":"比利时 ",
  "BW":"博茨瓦纳 ",
  "BT":"不丹 ",
  "BN":"文莱达鲁萨兰国 ",
  "BB":"巴巴多斯",
  "BR":"巴西 ",
  "BO":"多民族玻利维亚国 ",
  "BM":"",
  "BZ":"伯利兹 ",
  "BY":"白俄罗斯 ",
  "BL":"",
  "BS":"巴哈马 ",
  "BH":"巴林 ",
  "BA":"波斯尼亚和黑塞哥维那 ",
  "BG":"保加利亚 ",
  "BD":"孟加拉国 ",
  "BF":"布基纳法索 ",
  "BJ":"贝宁 ",
  "BI":"布隆迪 ",
  "AZ":"阿塞拜疆 ",
  "AT":"奥地利",
  "AU":"澳大利亚 ",
  "TF":"",
  "AQ":"",
  "AS":"",
  "AM":"亚美尼亚",
  "AR":"阿根廷",
  "AE":"阿拉伯联合酋长国 ",
  "AD":"安道尔",
  "AX":"",
  "AL":"阿尔巴尼亚",
  "AI":"",
  "AO":"安哥拉",
  "AF":"阿富汗",
  "AG":"安提瓜和巴布达",
  "AW":""

}; 

export const CountryNamesFRE = {
  "KU":"", // KUNASHIR
  "AP":"",
  "QQ":"", // TERRITORY WITH SUDAN
  "QG":"", // TERRITORY WITH EGYPT
  "TV":"TUVALU (LES)",
  "BV":"",
  "GI":"",
  "GO":"",
  "JU":"",
  "UM-DQ":"",
  "UM-FQ":"",
  "UM-HQ":"",
  "UM-JQ":"",
  "UM-MQ":"",
  "UM-WQ":"",
  "BQ":"",
  "NL":"LE ROYAUME DES PAYS-BAS",//"PAYS-BAS (LES)",
  "ZW":"ZIMBABWE (LE)",
  "ZM":"ZAMBIE (LA)",
  "ZA":"AFRIQUE DU SUD (L')",
  "YE":"YÉMEN (LE)",
  "WS":"SAMOA (LE)",
  "WF":"",
  "PS":"TERRITOIRE PALESTINIEN OCCUPÉ",//Occupied Palestinian Territory
  //"PS":"ÉTAT DE PALESTINE (L')",
  //"PX":"ÉTAT DE PALESTINE (L')",
  "VU":"VANUATU",
  "VN":"VIET NAM (LE)",
  "VI":"",
  "VG":"",
  "VE":"VENEZUELA (RÉPUBLIQUE BOLIVARIENNE DU)",
  "VC":"SAINT-VINCENT-ET-LES GRENADINES",
  "VA":"",
  "UZ":"OUZBÉKISTAN (L')",
  "US":"ÉTATS-UNIS D'AMÉRIQUE (LES)",
  "UY":"URUGUAY (L')",
  "UA":"UKRAINE (L')",
  "UG":"OUGANDA (L')",
  "TZ":"RÉPUBLIQUE-UNIE DE TANZANIE (LA)",
  "TW":"",
  "TR":"TÜRKİYE",//"TÜRKIYE",//"TURQUIE (LA)",
  "TN":"TUNISIE (LA)",
  "TT":"TRINITÉ-ET-TOBAGO (LA)",
  "TO":"TONGA (LES)",
  "TL":"TIMOR-LESTE (LE)",
  "TM":"TURKMÉNISTAN (LE)",
  "TK":"",
  "TJ":"TADJIKISTAN (LE)",
  "TH":"THAÏLANDE (LA)",
  "TG":"TOGO (LE)",
  "TD":"TCHAD (LE)",
  "TC":"",
  "SY":"RÉPUBLIQUE ARABE SYRIENNE (LA)",
  "SC":"SEYCHELLES (LES)",
  "SX":"",
  "SZ":"ESWATINI (L')",
  "SE":"SUÈDE (LA)",
  "SI":"SLOVÉNIE (LA)",
  "SK":"SLOVAQUIE (LA)",
  "SR":"SURINAME (LE)",
  "ST":"SAO TOMÉ-ET-PRINCIPE",
  "RS":"SERBIE (LA)",
  "PM":"",
  "SO":"SOMALIE (LA)",
  "SM":"SAINT-MARIN",
  "SV":"EL SALVADOR",
  "SL":"SIERRA LEONE (LA)",
  "SB":"ÎLES SALOMON (LES)",
  "SH":"",
  "GS":"",
  "SG":"SINGAPOUR",
  "SN":"SÉNÉGAL (LE)",
  "SS":"SOUDAN DU SUD (LE)",
  "SD":"SOUDAN (LE)",
  "SA":"ARABIE SAOUDITE (L')",
  "EH":"",
  "RW":"RWANDA (LE)",
  "RU":"FÉDÉRATION DE RUSSIE (LA)",
  "RO":"ROUMANIE (LA)",
  "RE":"",
  "QA":"QATAR (LE)",
  "PF":"",
  "PY":"PARAGUAY (LE)",
  "PT":"PORTUGAL (LE)",
  "KP":"RÉPUBLIQUE POPULAIRE DÉMOCRATIQUE DE CORÉE (LA)",
  "PR":"",
  "PL":"POLOGNE (LA)",
  "PG":"PAPOUASIE-NOUVELLE-GUINÉE (LA)",
  "PW":"PALAOS (LES)",
  "PH":"PHILIPPINES (LES)",
  "PE":"PÉROU (LE)",
  "PN":"",
  "PA":"PANAMA (LE)",
  "PK":"PAKISTAN (LE)",
  "OM":"OMAN",
  "NZ":"NOUVELLE-ZÉLANDE (LA)",
  "SJ":"",
  "NR":"NAURU",
  "NP":"NÉPAL (LE)",
  "NO":"NORVÈGE (LA)",
  "NU":"NIOUÉ",
  "NI":"NICARAGUA (LE)",
  "NG":"NIGÉRIA (LE)",
  "NF":"",
  "NE":"NIGER (LE)",
  "NC":"",
  "NA":"NAMIBIE (LA)",
  "YT":"",
  "MY":"MALAISIE (LA)",
  "MW":"MALAWI (LE)",
  "MU":"MAURICE",
  "MQ":"",
  "MS":"",
  "MR":"MAURITANIE (LA)",
  "MZ":"MOZAMBIQUE (LE)",
  "MP":"",
  "MN":"MONGOLIE (LA)",
  "ME":"MONTÉNÉGRO (LE)",
  "MM":"MYANMAR (LE)",
  "MT":"MALTE",
  "ML":"MALI (LE)",
  "MK":"MACÉDOINE DU NORD (LA)",
  "MH":"ÎLES MARSHALL (LES)",
  "MX":"MEXIQUE (LE)",
  "MV":"MALDIVES (LES)",
  "MG":"MADAGASCAR",
  "MD":"RÉPUBLIQUE DE MOLDOVA (LA)",
  "MC":"MONACO",
  "MA":"MAROC (LE)",
  "MF":"",
  "MO":"",
  "LV":"LETTONIE (LA)",
  "LU":"LUXEMBOURG (LE)",
  "LT":"LITUANIE (LA)",
  "LS":"LESOTHO (LE)",
  "LK":"SRI LANKA",
  "LI":"LIECHTENSTEIN (LE)",
  "LC":"SAINTE-LUCIE",
  "LY":"LIBYE (LA)",
  "LR":"LIBÉRIA (LE)",
  "LB":"LIBAN (LE)",
  "LA":"RÉPUBLIQUE DÉMOCRATIQUE POPULAIRE LAO (LA)",
  "KW":"KOWEÏT (LE)",
  "XK":"",
  "KR":"RÉPUBLIQUE DE CORÉE (LA)",
  "KN":"SAINT-KITTS-ET-NEVIS",
  "KI":"KIRIBATI",
  "KH":"CAMBODGE (LE)",
  "KG":"KIRGHIZISTAN (LE)",
  "KE":"KENYA (LE)",
  "KZ":"KAZAKHSTAN (LE)",
  "JP":"JAPON (LE)",
  "JO":"JORDANIE (LA)",
  "JE":"",
  "JM":"JAMAÏQUE (LA)",
  "IT":"ITALIE (L')",
  "IL":"ISRAËL",
  "IS":"ISLANDE (L')",
  "IQ":"IRAQ (L')",
  "IR":"IRAN (RÉPUBLIQUE ISLAMIQUE D')",
  "IE":"IRLANDE (L')",
  "IO":"",
  "IN":"INDE (L')",
  "IM":"",
  "ID":"INDONÉSIE (L')",
  "HU":"HONGRIE (LA)",
  "HT":"HAÏTI",
  "HR":"CROATIE (LA)",
  "HN":"HONDURAS (LE)",
  "HM":"",
  "HK":"", // HONG KONG?
  "GY":"GUYANA (LE)",
  "GU":"",
  "GF":"",
  "GT":"GUATEMALA (LE)",
  "GL":"",
  "GD":"GRENADE (LA)",
  "GR":"GRÈCE (LA)",
  "GQ":"GUINÉE ÉQUATORIALE (LA)",
  "GW":"GUINÉE-BISSAU (LA)",
  "GM":"GAMBIE (LA)",
  "GP":"",
  "GN":"GUINÉE (LA)",
  "GH":"GHANA (LE)",
  "GG":"",
  "GE":"GÉORGIE (LA)",
  "GA":"GABON (LE)",
  "FR":"FRANCE (LA)",
  "FM":"MICRONÉSIE (ÉTATS FÉDÉRÉS DE)",
  "FO":"",
  "FK":"",
  "FJ":"FIDJI (LES)",
  "FI":"FINLANDE (LA)",
  "ET":"ÉTHIOPIE (L')",
  "EE":"ESTONIE (L')",
  "ES":"ESPAGNE (L')",
  "ER":"ÉRYTHRÉE (L')",
  "GB":"ROYAUME-UNI DE GRANDE-BRETAGNE ET D'IRLANDE DU NORD (LE)",
  "EG":"ÉGYPTE (L')",
  "EC":"ÉQUATEUR (L')",
  "DZ":"ALGÉRIE (L')",
  "DO":"RÉPUBLIQUE DOMINICAINE (LA)",
  "DK":"DANEMARK (LE)",
  "DM":"DOMINIQUE (LA)",
  "DJ":"DJIBOUTI",
  "DE":"ALLEMAGNE (L')",
  "CZ":"TCHÉQUIE (LA)",
  "CY":"CHYPRE",
  "KY":"",
  "CX":"",
  "CW":"",
  "CU":"CUBA",
  "CR":"COSTA RICA (LE)",
  "CV":"CABO VERDE",
  "KM":"COMORES (LES)",
  "CO":"COLOMBIE (LA)",
  "CK":"ÎLES COOK (LES)",
  "CG":"CONGO (LE)",
  "CD":"RÉPUBLIQUE DÉMOCRATIQUE DU CONGO (LA)",
  "CM":"CAMEROUN (LE)",
  "CI":"CÔTE D'IVOIRE (LA)",
  "CN":"CHINE (LA)",
  "CL":"CHILI (LE)",
  "CH":"SUISSE (LA)",
  "CC":"",
  "CA":"CANADA (LE)",
  "CF":"RÉPUBLIQUE CENTRAFRICAINE (LA)",
  "BE":"BELGIQUE (LA)",
  "BW":"BOTSWANA (LE)",
  "BT":"BHOUTAN (LE)",
  "BN":"BRUNÉI DARUSSALAM (LE)",
  "BB":"BARBADE (LA)",
  "BR":"BRÉSIL (LE)",
  "BO":"BOLIVIE (RÉPUBLIQUE BOLIVARIENNE DU)", //UPDATED 4-1 (WAS "BOLIVIE (ÉTAT PLURINATIONAL DE)",
  "BM":"",
  "BZ":"BELIZE (LE)",
  "BY":"BÉLARUS (LE)",
  "BL":"",
  "BS":"BAHAMAS (LES)",
  "BH":"BAHREÏN",
  "BA":"BOSNIE-HERZÉGOVINE (LA)",
  "BG":"BULGARIE (LA)",
  "BD":"BANGLADESH (LE)",
  "BF":"BURKINA FASO (LE)",
  "BJ":"BÉNIN (LE)",
  "BI":"BURUNDI (LE)",
  "AZ":"AZERBAÏDJAN (L')",
  "AT":"AUTRICHE (L')",
  "AU":"AUSTRALIE (L')",
  "TF":"",
  "AQ":"",
  "AS":"",
  "AM":"ARMÉNIE (L')",
  "AR":"ARGENTINE (L')",
  "AE":"ÉMIRATS ARABES UNIS (LES)",
  "AD":"ANDORRE (L')",
  "AX":"",
  "AL":"ALBANIE (L')",
  "AI":"",
  "AO":"ANGOLA (L')",
  "AF":"AFGHANISTAN (L')",
  "AG":"ANTIGUA-ET-BARBUDA",
  "AW":""
};

export const CountryNamesESP = {
  "KU":"", // KUNASHIR
  "AP":"",
  "QQ":"", // TERRITORY WITH SUDAN
  "QG":"", // TERRITORY WITH EGYPT
  "TV":"TUVALU",
  "BV":"",
  "GI":"",
  "GO":"",
  "JU":"",
  "UM-DQ":"",
  "UM-FQ":"",
  "UM-HQ":"",
  "UM-JQ":"",
  "UM-MQ":"",
  "UM-WQ":"",
  "BQ":"",
  "NL":"EL REINO DE LOS PAÍSES BAJOS",//"PAÍSES BAJOS (LOS)",
  "ZW":"ZIMBABWE",
  "ZM":"ZAMBIA",
  "ZA":"SUDÁFRICA",
  "YE":"YEMEN (EL)",
  "WS":"SAMOA",
  "WF":"",
  "PS":"TERRITORIO PALESTINO OCUPADO", //Occupied Palestinian Territory
  //"PS":"ESTADO DE PALESTINA (EL)",
  //"PX":"ESTADO DE PALESTINA (EL)",
  "VU":"VANUATU",
  "VN":"VIET NAM",
  "VI":"",
  "VG":"",
  "VE":"VENEZUELA (REPÚBLICA BOLIVARIANA DE)",
  "VC":"SAN VICENTE Y LAS GRANADINAS",
  "VA":"",
  "UZ":"UZBEKISTÁN",
  "US":"ESTADOS UNIDOS DE AMÉRICA (LOS)",
  "UY":"URUGUAY (EL)",
  "UA":"UCRANIA",
  "UG":"UGANDA",
  "TZ":"REPÚBLICA UNIDA DE TANZANÍA (LA)",
  "TW":"",
  "TR":"TÜRKİYE",//"TÜRKIYE",//"TURQUÍA",
  "TN":"TÚNEZ",
  "TT":"TRINIDAD Y TABAGO",
  "TO":"",
  "TL":"TIMOR-LESTE",
  "TM":"TURKMENISTÁN",
  "TK":"",
  "TJ":"TAYIKISTÁN",
  "TH":"TAILANDIA",
  "TG":"TOGO (EL)",
  "TD":"CHAD (EL)",
  "TC":"",
  "SY":"REPÚBLICA ÁRABE SIRIA (LA)",
  "SC":"SEYCHELLES",
  "SX":"",
  "SZ":"ESWATINI",
  "SE":"SUECIA",
  "SI":"ESLOVENIA",
  "SK":"ESLOVAQUIA",
  "SR":"SURINAME",
  "ST":"SANTO TOMÉ Y PRÍNCIPE",
  "RS":"SERBIA",
  "PM":"",
  "SO":"SOMALIA",
  "SM":"SAN MARINO",
  "SV":"EL SALVADOR",
  "SL":"SIERRA LEONA",
  "SB":"ISLAS SALOMÓN (LAS)",
  "SH":"",
  "GS":"",
  "SG":"SINGAPUR",
  "SN":"SENEGAL (EL)",
  "SS":"SUDÁN DEL SUR",
  "SD":"SUDÁN (EL)",
  "SA":"ARABIA SAUDITA (LA)",
  "EH":"",
  "RW":"RWANDA",
  "RU":"FEDERACIÓN DE RUSIA (LA)",
  "RO":"RUMANIA ",
  "RE":"",
  "QA":"QATAR ",
  "PF":"",
  "PY":"PANAMÁ ",
  "PT":"PORTUGAL ",
  "KP":"REPÚBLICA POPULAR DEMOCRÁTICA DE COREA (LA) ",
  "PR":"",
  "PL":"POLONIA ",
  "PG":"PAPUA NUEVA GUINEA ",
  "PW":"PALAU ",
  "PH":"FILIPINAS ",
  "PE":"PERÚ (EL) ",
  "PN":"",
  "PA":"PANAMÁ ",
  "PK":"PAKISTÁN (EL) ",
  "OM":"OMÁN ",
  "NZ":"NUEVA ZELANDIA ",
  "SJ":"",
  "NR":"NAURU ",
  "NP":"NEPAL ",
  "NO":"NORUEGA ",
  "NU":"NIUE",
  "NI":"NICARAGUA ",
  "NG":"NIGERIA ",
  "NF":"",
  "NE":"NÍGER (EL) ",
  "NC":"",
  "NA":"NAMIBIA",
  "YT":"",
  "MY":"MALASIA ",
  "MW":"MALAWI ",
  "MU":"MAURICIO ",
  "MQ":"",
  "MS":"",
  "MR":"MAURITANIA ",
  "MZ":"MOZAMBIQUE ",
  "MP":"",
  "MN":"MONGOLIA ",
  "ME":"MONTENEGRO ",
  "MM":"MYANMAR ",
  "MT":"MALTA",
  "ML":"MALÍ ",
  "MK":"MACEDONIA DEL NORTE ",
  "MH":"ISLAS MARSHALL (LAS) ",
  "MX":"MÉXICO ",
  "MV":"MALDIVAS ",
  "MG":"MADAGASCAR ",
  "MD":"REPÚBLICA DE MOLDOVA (LA) ",
  "MC":"MÓNACO ",
  "MA":"MARRUECOS ",
  "MF":"",
  "MO":"", // MACAU??
  "LV":"LETONIA ",
  "LU":"LUXEMBURGO ",
  "LT":"LITUANIA ",
  "LS":"LESOTHO ",
  "LK":"SRI LANKA ",
  "LI":"LIECHTENSTEIN ",
  "LC":"SANTA LUCÍA ",
  "LY":"LIBIA ",
  "LR":"LIBERIA",
  "LB":"LÍBANO (EL)",
  "LA":"REPÚBLICA DEMOCRÁTICA POPULAR LAO (LA)",
  "KW":"KUWAIT",
  "XK":"",
  "KR":"REPÚBLICA DE COREA (LA)",
  "KN":"SAINT KITTS Y NEVIS",
  "KI":"KIRIBATI",
  "KH":"CAMBOYA",
  "KG":"KIRGUISTÁN",
  "KE":"KENYA",
  "KZ":"KAZAJSTÁN",
  "JP":"JAPÓN (EL)",
  "JO":"JORDANIA",
  "JE":"",
  "JM":"JAMAICA",
  "IT":"ITALIA",
  "IL":"ISRAEL",
  "IS":"ISLANDIA",
  "IQ":"IRAQ (EL)",
  "IR":"IRÁN (REPÚBLICA ISLÁMICA DEL)",
  "IE":"IRLANDA",
  "IO":"",
  "IN":"INDIA (LA)",
  "IM":"",
  "ID":"INDONESIA",
  "HU":"HUNGRÍA",
  "HT":"HAITÍ",
  "HR":"CROACIA",
  "HN":"HONDURAS",
  "HM":"",
  "HK":"",
  "GY":"GUYANA",
  "GU":"",
  "GF":"",
  "GT":"GUATEMALA",
  "GL":"",
  "GD":"GRANADA",
  "GR":"GRECIA",
  "GQ":"GUINEA ECUATORIAL",
  "GW":"GUINEA-BISSAU",
  "GM":"GAMBIA",
  "GP":"",
  "GN":"GUINEA",
  "GH":"GHANA",
  "GG":"",
  "GE":"GEORGIA",
  "GA":"GABÓN (EL)",
  "FR":"FRANCIA",
  "FM":"MICRONESIA (ESTADOS FEDERADOS DE)",
  "FO":"",
  "FK":"",
  "FJ":"FIJI",
  "FI":"FINLANDIA",
  "ET":"ETIOPÍA",
  "EE":"ESTONIA",
  "ES":"ESPAÑA",
  "ER":"ERITREA",
  "GB":"REINO UNIDO DE GRAN BRETAÑA E IRLANDA DEL NORTE (EL)",
  "EG":"EGIPTO",
  "EC":"ECUADOR (EL)",
  "DZ":"ARGELIA",
  "DO":"REPÚBLICA DOMINICANA (LA)",
  "DK":"DINAMARCA",
  "DM":"DOMINICA",
  "DJ":"DJIBOUTI",
  "DE":"ALEMANIA",
  "CZ":"CHEQUIA",
  "CY":"CHIPRE",
  "KY":"",
  "CX":"",
  "CW":"",
  "CU":"CUBA",
  "CR":"COSTA RICA",
  "CV":"CABO VERDE",
  "KM":"COMORAS (LAS)",
  "CO":"COLOMBIA",
  "CK":"ISLAS COOK (LAS)",
  "CG":"CONGO (EL)",
  "CD":"REPÚBLICA DEMOCRÁTICA DEL CONGO (LA)",
  "CM":"CAMERÚN (EL)",
  "CI":"CÔTE D’IVOIRE",
  "CN":"CHINA",
  "CL":"CHILE",
  "CH":"SUIZA",
  "CC":"",
  "CA":"CANADÁ (EL)",
  "CF":"REPÚBLICA CENTROAFRICANA (LA)",
  "BE":"BÉLGICA",
  "BW":"BOTSWANA",
  "BT":"BHUTÁN",
  "BN":"BRUNEI DARUSSALAM",
  "BB":"BARBADOS",
  "BR":"BRASIL (EL)",
  "BO":"BOLIVIA (ESTADO PLURINACIONAL DE)",
  "BM":"",
  "BZ":"BELICE",
  "BY":"BELARÚS",
  "BL":"",
  "BS":"BAHAMAS (LAS)",
  "BH":"BAHREIN",
  "BA":"BOSNIA Y HERZEGOVINA",
  "BG":"BULGARIA",
  "BD":"BANGLADESH",
  "BF":"BURKINA FASO",
  "BJ":"BENIN",
  "BI":"BURUNDI",
  "AZ":"AZERBAIYÁN",
  "AT":"AUSTRIA",
  "AU":"AUSTRALIA",
  "TF":"",
  "AQ":"",
  "AS":"",
  "AM":"ARMENIA",
  "AR":"ARGENTINA (LA)",
  "AE":"EMIRATOS ÁRABES UNIDOS (LOS)",
  "AD":"ANDORRA",
  "AX":"",
  "AL":"ALBANIA",
  "AI":"",
  "AO":"ANGOLA",
  "AF":"AFGANISTÁN (EL)",
  "AG":"ANTIGUA Y BARBUDA",
  "AW":""

}; 

export const CountryNamesRUS = {
  "KU":"", // KUNASHIR
  "AP":"",
  "QQ":"", // TERRITORY WITH SUDAN
  "QG":"", // TERRITORY WITH EGYPT
  "TV":"ТУВАЛУ",
  "BV":"",
  "GI":"",
  "GO":"",
  "JU":"",
  "UM-DQ":"",
  "UM-FQ":"",
  "UM-HQ":"",
  "UM-JQ":"",
  "UM-MQ":"",
  "UM-WQ":"",
  "BQ":"",
  "NL":"КОРОЛЕВСТВО НИДЕРЛАНДОВ",//"НИДЕРЛАНДЫ",
  "ZW":"ЗИМБАБВЕ",
  "ZM":"ЗАМБИЯ",
  "ZA":"ЮЖНАЯ АФРИКА",
  "YE":"ЙЕМЕН",
  "WS":"САМОА",
  "WF":"",
  "PS":"ОККУПИРОВАННАЯ ПАЛЕСТИНСКАЯ ТЕРРИТОРИЯ", //Occupied Palestinian Territory
  //"PS":"ГОСУДАРСТВО ПАЛЕСТИНА",
  //"PX":"ГОСУДАРСТВО ПАЛЕСТИНА",
  "VU":"ВАНУАТУ",
  "VN":"ВЬЕТНАМ",
  "VI":"",
  "VG":"",
  "VE":"ВЕНЕСУЭЛА (БОЛИВАРИАНСКАЯ РЕСПУБЛИКА)",
  "VC":"СЕНТ-ВИНСЕНТ И ГРЕНАДИНЫ",
  "VA":"",
  "UZ":"УЗБЕКИСТАН",
  "US":"СОЕДИНЕННЫЕ ШТАТЫ АМЕРИКИ",
  "UY":"УРУГВАЙ",
  "UA":"УКРАИНА",
  "UG":"УГАНДА",
  "TZ":"ОБЪЕДИНЕННАЯ РЕСПУБЛИКА ТАНЗАНИЯ",
  "TW":"",
  "TR":"ТУРЦИЯ",//"ТУРЦИЯ",
  "TN":"ТУНИС",
  "TT":"ТРИНИДАД И ТОБАГО",
  "TO":"",
  "TL":"ТИМОР-ЛЕШТИ",
  "TM":"ТУРКМЕНИСТАН",
  "TK":"",
  "TJ":"ТАДЖИКИСТАН",
  "TH":"ТАИЛАНД",
  "TG":"ТОГО",
  "TD":"ЧАД",
  "TC":"",
  "SY":"СИРИЙСКАЯ АРАБСКАЯ РЕСПУБЛИКА",
  "SC":"СЕЙШЕЛЬСКИЕ ОСТРОВА",
  "SX":"",
  "SZ":"ЭСВАТИНИ",
  "SE":"ШВЕЦИЯ",
  "SI":"СЛОВЕНИЯ",
  "SK":"СЛОВАКИЯ",
  "SR":"СУРИНАМ",
  "ST":"САН-ТОМЕ И ПРИНСИПИ",
  "RS":"СЕРБИЯ",
  "PM":"",
  "SO":"СОМАЛИ",
  "SM":"САН-МАРИНО",
  "SV":"САЛЬВАДОР",
  "SL":"СЬЕРРА-ЛЕОНЕ",
  "SB":"СОЛОМОНОВЫ ОСТРОВА",
  "SH":"",
  "GS":"",
  "SG":"СИНГАПУР",
  "SN":"СЕНЕГАЛ",
  "SS":"ЮЖНЫЙ СУДАН",
  "SD":"СУДАН",
  "SA":"САУДОВСКАЯ АРАВИЯ",
  "EH":"",
  "RW":"РУАНДА",
  "RU":"РОССИЙСКАЯ ФЕДЕРАЦИЯ",
  "RO":"РУМЫНИЯ",
  "RE":"",
  "QA":"КАТАР",
  "PF":"",
  "PY":"ПАРАГВАЙ",
  "PT":"ПОРТУГАЛИЯ",
  "KP":"КОРЕЙСКАЯ НАРОДНО-ДЕМОКРАТИЧЕСКАЯ РЕСПУБЛИКА",
  "PR":"",
  "PL":"ПОЛЬША",
  "PG":"ПАПУА — НОВАЯ ГВИНЕЯ",
  "PW":"ПАЛАУ",
  "PH":"ФИЛИППИНЫ",
  "PE":"ПЕРУ",
  "PN":"",
  "PA":"ПАНАМА",
  "PK":"ПАКИСТАН",
  "OM":"ОМАН",
  "NZ":"НОВАЯ ЗЕЛАНДИЯ",
  "SJ":"",
  "NR":"НАУРУ",
  "NP":"НЕПАЛ",
  "NO":"НОРВЕГИЯ",
  "NU":"НИУЭ",
  "NI":"НИКАРАГУА",
  "NG":"НИГЕРИЯ",
  "NF":"",
  "NE":"НИГЕР",
  "NC":"",
  "NA":"НАМИБИЯ",
  "YT":"",
  "MY":"МАЛАЙЗИЯ",
  "MW":"МАЛАВИ",
  "MU":"МАВРИКИЙ",
  "MQ":"",
  "MS":"",
  "MR":"МАВРИТАНИЯ",
  "MZ":"МОЗАМБИК",
  "MP":"",
  "MN":"МОНГОЛИЯ",
  "ME":"ЧЕРНОГОРИЯ",
  "MM":"МЬЯНМА",
  "MT":"МАЛЬТА",
  "ML":"МАЛИ",
  "MK":"СЕВЕРНАЯ МАКЕДОНИЯ",
  "MH":"МАРШАЛЛОВЫ ОСТРОВА",
  "MX":"МЕКСИКА",
  "MV":"МАЛЬДИВСКИЕ ОСТРОВА",
  "MG":"МАДАГАСКАР",
  "MD":"РЕСПУБЛИКА МОЛДОВА",
  "MC":"МОНАКО",
  "MA":"МАРОККО",
  "MF":"",
  "MO":"",
  "LV":"ЛАТВИЯ",
  "LU":"ЛЮКСЕМБУРГ",
  "LT":"ЛИТВА",
  "LS":"ЛЕСОТО",
  "LK":"ШРИ-ЛАНКА",
  "LI":"ЛИХТЕНШТЕЙН",
  "LC":"СЕНТ-ЛЮСИЯ",
  "LY":"ЛИВИЯ",
  "LR":"ЛИБЕРИЯ",
  "LB":"ЛИВАН",
  "LA":"ЛАОССКАЯ НАРОДНО-ДЕМОКРАТИЧЕСКАЯ РЕСПУБЛИКА",
  "KW":"КУВЕЙТ",
  "XK":"",
  "KR":"РЕСПУБЛИКА КОРЕЯ",
  "KN":"СЕНТ-КИТС И НЕВИС",
  "KI":"КИРИБАТИ",
  "KH":"КАМБОДЖА",
  "KG":"КЫРГЫЗСТАН",
  "KE":"КЕНИЯ",
  "KZ":"КАЗАХСТАН",
  "JP":"ЯПОНИЯ",
  "JO":"ИОРДАНИЯ",
  "JE":"",
  "JM":"ЯМАЙКА",
  "IT":"ИТАЛИЯ",
  "IL":"ИЗРАИЛЬ",
  "IS":"ИСЛАНДИЯ",
  "IQ":"ИРАК",
  "IR":"ИРАН (ИСЛАМСКАЯ РЕСПУБЛИКА)",
  "IE":"ИРЛАНДИЯ",
  "IO":"",
  "IN":"ИНДИЯ",
  "IM":"",
  "ID":"ИНДОНЕЗИЯ",
  "HU":"ВЕНГРИЯ",
  "HT":"ГАИТИ",
  "HR":"ХОРВАТИЯ",
  "HN":"ГОНДУРАС",
  "HM":"",
  "HK":"",
  "GY":"ГАЙАНА",
  "GU":"",
  "GF":"",
  "GT":"ГВАТЕМАЛА",
  "GL":"",
  "GD":"ГРЕНАДА",
  "GR":"ГРЕЦИЯ",
  "GQ":"ЭКВАТОРИАЛЬНАЯ ГВИНЕЯ",
  "GW":"ГВИНЕЯ-БИСАУ",
  "GM":"ГАМБИЯ",
  "GP":"",
  "GN":"ГВИНЕЯ",
  "GH":"ГАНА",
  "GG":"",
  "GE":"ГРУЗИЯ",
  "GA":"ГАБОН",
  "FR":"ФРАНЦИЯ",
  "FM":"МИКРОНЕЗИЯ (ФЕДЕРАТИВНЫЕ ШТАТЫ)",
  "FO":"",
  "FK":"",
  "FJ":"ФИДЖИ",
  "FI":"ФИНЛЯНДИЯ",
  "ET":"ЭФИОПИЯ",
  "EE":"ЭСТОНИЯ",
  "ES":"ИСПАНИЯ",
  "ER":"ЭРИТРЕЯ",
  "GB":"СОЕДИНЕННОЕ КОРОЛЕВСТВО ВЕЛИКОБРИТАНИИ И СЕВЕРНОЙ ИРЛАНДИИ",
  "EG":"ЕГИПЕТ",
  "EC":"ЭКВАДОР",
  "DZ":"АЛЖИР",
  "DO":"ДОМИНИКАНСКАЯ РЕСПУБЛИКА",
  "DK":"ДАНИЯ",
  "DM":"ДОМИНИКА",
  "DJ":"ДЖИБУТИ",
  "DE":"ГЕРМАНИЯ",
  "CZ":"ЧЕХИЯ",
  "CY":"КИПР",
  "KY":"",
  "CX":"",
  "CW":"",
  "CU":"КУБА",
  "CR":"КОСТА-РИКА",
  "CV":"КАБО-ВЕРДЕ",
  "KM":"КОМОРСКИЕ ОСТРОВА",
  "CO":"КОЛУМБИЯ",
  "CK":"ОСТРОВА КУКА",
  "CG":"КОНГО",
  "CD":"ДЕМОКРАТИЧЕСКАЯ РЕСПУБЛИКА КОНГО",
  "CM":"КАМЕРУН",
  "CI":"КОТ-Д’ИВУАР",
  "CN":"КИТАЙ",
  "CL":"ЧИЛИ",
  "CH":"ШВЕЙЦАРИЯ",
  "CC":"",
  "CA":"КАНАДА",
  "CF":"ЦЕНТРАЛЬНОАФРИКАНСКАЯ РЕСПУБЛИКА",
  "BE":"БЕЛЬГИЯ",
  "BW":"БОТСВАНА",
  "BT":"БУТАН",
  "BN":"БРУНЕЙ-ДАРУССАЛАМ",
  "BB":"БАРБАДОС",
  "BR":"БРАЗИЛИЯ",
  "BO":"БОЛИВИЯ (МНОГОНАЦИОНАЛЬНОЕ ГОСУДАРСТВО)",
  "BM":"",
  "BZ":"БЕЛИЗ",
  "BY":"БЕЛАРУСЬ",
  "BL":"",
  "BS":"БАГАМСКИЕ ОСТРОВА",
  "BH":"БАХРЕЙН",
  "BA":"БОСНИЯ И ГЕРЦЕГОВИНА",
  "BG":"БОЛГАРИЯ",
  "BD":"БАНГЛАДЕШ",
  "BF":"БУРКИНА-ФАСО",
  "BJ":"БЕНИН",
  "BI":"БУРУНДИ",
  "AZ":"АЗЕРБАЙДЖАН",
  "AT":"АВСТРИЯ",
  "AU":"АВСТРАЛИЯ",
  "TF":"",
  "AQ":"",
  "AS":"",
  "AM":"АРМЕНИЯ",
  "AR":"АРГЕНТИНА",
  "AE":"ОБЪЕДИНЕННЫЕ АРАБСКИЕ ЭМИРАТЫ",
  "AD":"АНДОРРА",
  "AX":"",
  "AL":"АЛБАНИЯ",
  "AI":"",
  "AO":"АНГОЛА",
  "AF":"АФГАНИСТАН",
  "AG":"АНТИГУА И БАРБУДА",
  "AW":""

}; 

export const CountryNamesARB = {
  "KU":"", // Kunashir
  "AP":"",
  "QQ":"", // Territory with Sudan
  "QG":"", // Territory with Egypt
  "TV":"توفالو",
  "BV":"",
  "GI":"",
  "GO":"",
  "JU":"",
  "UM-DQ":"",
  "UM-FQ":"",
  "UM-HQ":"",
  "UM-JQ":"",
  "UM-MQ":"",
  "UM-WQ":"",
  "BQ":"",
  "NL":"مملكة هولندا",//"هولندا",
  "ZW":"زمبابوي",
  "ZM":"زامبيا",
  "ZA":"جنوب أفريقيا",
  "YE":"اليمن",
  "WS":"ساموا",
  "WF":"",
  "TWN":"",
  "xJK":"",
  "PS":"الأرض الفلسطينية المحتلة", //Occupied Palestinian Territory
  //"PS":"دولة فلسطين",
  //"PX":"دولة فلسطين",
  "VU":"فانواتو",
  "VN":"فييت نام",
  "VI":"",
  "VG":"",
  "FLK":"",
  "VE":"فنزويلا (جمهورية - البوليفارية)",
  "VC":"سانت فنسنت وجزر غرينادين",
  "VA":"الكرسي الرسولي",
  "UZ":"أوزبكستان",
  "US":"الولايات المتحدة الأمريكية",
  "UY":"أوروغواي",
  "UA":"أوكرانيا",
  "UG":"أوغندا",
  "TZ":"جمهورية تنزانيا المتحدة",
  "TW":"",
  "TR":"تركيا",//"تركيا",
  "TN":"تونس",
  "TT":"ترينيداد وتوباغو",
  "TO":"تونغا",
  "TL":"تيمور- ليشتي",
  "TM":"تركمانستان",
  "TK":"",
  "TJ":"طاجيكستان",
  "TH":"تايلند",
  "TG":"توغو",
  "TD":"تشاد",
  "TC":"",
  "SY":"الجمهورية العربية السورية",
  "SC":"سيشيل",
  "SX":"",
  "SZ":"إسواتيني",
  "SE":"السويد",
  "SI":"سلوفينيا",
  "SK":"سلوفاكيا",
  "SR":"سورينام",
  "ST":"سان تومي وبرينسيبي",
  "RS":"صربيا",
  "PM":"",
  "SO":"الصومال",
  "SM":"سان مارينو",
  "SV":"السلفادور",
  "SL":"سيراليون",
  "SB":"جزر سليمان",
  "SH":"",
  "GS":"",
  "SG":"سنغافورة",
  "SN":"السنغال",
  "SS":"جنوب السودان",
  "SD":"السودان",
  "SA":"المملكة العربية السعودية",
  "EH":"",
  "RW":"رواندا",
  "RU":"الاتحاد الروسي",
  "RO":"رومانيا",
  "RE":"",
  "QA":"قطر",
  "PF":"",
  "PY":"باراغواي",
  "PT":"البرتغال",
  "KP":"جمهورية كوريا الشعبية الديمقراطية",
  "PR":"",
  "PL":"بولندا",
  "PG":"بابوا غينيا الجديدة",
  "PW":"بالاو",
  "PH":"الفلبين",
  "PE":"بيرو",
  "PN":"",
  "PA":"بنما",
  "PK":"باكستان",
  "OM":"عمان",
  "NZ":"نيوزيلندا",
  "SJ":"",
  "NR":"ناورو",
  "NP":"نيبال",
  "NO":"النرويج",
  "NU":"نيوي",
  "NI":"نيكاراغوا",
  "NG":"نيجيريا",
  "NF":"",
  "NE":"النيجر",
  "NC":"",
  "NA":"",
  "YT":"",
  "MY":"ماليزيا",
  "MW":"ملاوي",
  "MU":"موريشيوس",
  "MQ":"",
  "MS":"",
  "MR":"موريتانيا",
  "MZ":"موزامبيق",
  "MP":"",
  "MN":"منغوليا",
  "ME":"الجبل الأسود",
  "MM":"ميانمار",
  "MT":"مالطة",
  "ML":"مالي",
  "MK":"مقدونيا الشمالية",
  "MH":"جزر مارشال",
  "MX":"المكسيك",
  "MV":"ملديف",
  "MG":"مدغشقر",
  "MD":"جمهورية مولدوفا",
  "MC":"موناكو",
  "MA":"المغرب",
  "MF":"",
  "MO":"",
  "LV":"لاتفيا",
  "LU":"لكسمبرغ",
  "LT":"ليتوانيا",
  "LS":"ليسوتو",
  "LK":"سري لانكا",
  "LI":"ليختنشتاين",
  "LC":"سانت لوسيا",
  "LY":"ليبيا",
  "LR":"ليبريا",
  "LB":"لبنان",
  "LA":"جمهورية لاو الديمقراطية الشعبية",
  "KW":"الكويت",
  "XK":"",
  "KR":"جمهورية كوريا",
  "KN":"سانت كيتس ونيفس",
  "KI":"كيريباس",
  "KH":"كمبوديا",
  "KG":"قيرغيزستان",
  "KE":"كينيا",
  "KZ":"كازاخستان",
  "JP":"اليابان",
  "JO":"الأردن",
  "JE":"",
  "JM":"جامايكا",
  "IT":"إيطاليا",
  "IL":"إسرائيل",
  "IS":"آيسلندا",
  "IQ":"العراق",
  "IR":"إيران (جمهورية - الإسلامية)",
  "IE":"أيرلندا",
  "IO":"",
  "IN":"الهند",
  "IM":"",
  "ID":"إندونيسيا",
  "HU":"هنغاريا",
  "HT":"هايتي",
  "HR":"كرواتيا",
  "HN":"هندوراس",
  "HM":"",
  "HK":"",
  "GY":"غيانا",
  "GU":"",
  "GF":"",
  "GT":"غواتيمالا",
  "GL":"",
  "GD":"غرينادا",
  "GR":"اليونان",
  "GQ":"غينيا الاستوائية",
  "GW":"غينيا - بيساو",
  "GM":"غامبيا",
  "GP":"",
  "GN":"غينيا",
  "GH":"غانا",
  "GG":"",
  "GE":"جورجيا",
  "GA":"غابون",
  "FR":"فرنسا",
  "FM":"ميكرونيزيا (ولايات - الموحدة)",
  "FO":"",
  "FK":"",
  "FJ":"فيجي",
  "FI":"فنلندا",
  "ET":"إثيوبيا",
  "EE":"إستونيا",
  "ES":"إسبانيا",
  "ER":"إريتريا",
  "GB":"المملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية",
  "EG":"مصر",
  "EC":"إكوادور",
  "DZ":"الجزائر",
  "DO":"الجمهورية الدومينيكية",
  "DK":"الدانمرك",
  "DM":"دومينيكا",
  "DJ":"جيبوتي",
  "DE":"ألمانيا",
  "CZ":"تشيكيا",
  "CY":"قبرص",
  "KY":"",
  "CX":"",
  "CW":"",
  "CU":"كوبا",
  "CR":"كوستاريكا",
  "CV":"كابو فيردي",
  "KM":"جزر القمر",
  "CO":"كولومبيا",
  "CK":"جزر كوك",
  "CG":"الكونغو",
  "CD":"جمهورية الكونغو الديمقراطية",
  "CM":"الكاميرون",
  "CI":"كوت ديفوار",
  "CN":"الصين",
  "CL":"شيلي",
  "CH":"سويسرا",
  "CC":"",
  "CA":"كندا",
  "CF":"جمهورية أفريقيا الوسطى",
  "BE":"بلجيكا",
  "BW":"بوتسوانا",
  "BT":"بوتان",
  "BN":"بروني دار السلام",
  "BB":"بربادوس",
  "BR":"البرازيل",
  "BO":"بوليفيا (دولة - المتعددة القوميات)",
  "BM":"",
  "BZ":"بليز",
  "BY":"بيلاروس",
  "BL":"",
  "BS":"جزر البهاما",
  "BH":"البحرين",
  "BA":"البوسنة والهرسك",
  "BG":"بلغاريا",
  "BD":"بنغلاديش",
  "BF":"بوركينا فاسو",
  "BJ":"بنن",
  "BI":"بوروندي",
  "AZ":"أذربيجان",
  "AT":"النمسا",
  "AU":"أستراليا",
  "TF":"",
  "AQ":"",
  "AS":"",
  "AM":"أرمينيا",
  "AR":"الأرجنتين",
  "AE":"الإمارات العربية المتحدة",
  "AD":"أندورا",
  "AX":"",
  "AL":"ألبانيا",
  "AI":"",
  "AO":"أنغولا",
  "AF":"أفغانستان",
  "AG":"أنتيغوا وبربودا",
  "AW":""
}